"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Components_1 = __importDefault(require("../Components"));
const Button_edit_display_1 = __importDefault(require("./editForm/Button.edit.display"));
const AriForm_1 = require("../../AriForm");
/**
 * The Edit Form function.
 * @param {...any} extend - The components that extend the edit form.
 * @returns {import('@ariform/core').Component[]} - The edit form components.
 */
function default_1(...extend) {
    return Components_1.default.baseEditForm([
        {
            key: 'display',
            components: [
                ...Button_edit_display_1.default,
                {
                    key: 'description',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'tabindex',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'shortcut',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'tooltip',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'resultType',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'modalEdit',
                    ignore: AriForm_1.AriForm.isBPM,
                },
            ]
        },
        {
            key: 'data',
            ignore: true,
        },
        {
            key: 'validation',
            ignore: true,
        },
        {
            key: 'api',
            components: [
                {
                    key: 'tags',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'properties',
                    ignore: AriForm_1.AriForm.isBPM
                }
            ]
        },
        {
            key: 'logic',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'layout',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'addons',
            ignore: AriForm_1.AriForm.isBPM,
        },
    ], ...extend);
}
exports.default = default_1;
